export default __webpack_public_path__ + "static/media/recent-off.6db8ac0c.svg";